"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withdrawAlphaTxb = exports.depositAlphaTxb = void 0;
const transactions_1 = require("@mysten/sui/transactions");
const index_js_1 = require("../index.js");
// import { getEstimatedGasBudget } from "./deposit.js";
const depositAlphaTxb = async (amount, address) => {
    const suiClient = (0, index_js_1.getSuiClient)();
    const txb = new transactions_1.Transaction();
    let coins = [];
    const receipt = await (0, index_js_1.getReceipts)("ALPHA", address, true);
    let currentCursor = null;
    do {
        const response = await suiClient.getCoins({
            owner: address,
            coinType: (0, index_js_1.getConf)().ALPHA_COIN_TYPE,
            cursor: currentCursor,
        });
        coins = coins.concat(response.data);
        // Check if there's a next page
        if (response.hasNextPage && response.nextCursor) {
            currentCursor = response.nextCursor;
        }
        else {
            // No more pages available
            // console.log("No more receipts available.");
            break;
        }
    } while (true);
    let coin;
    if (coins.length >= 1) {
        [coin] = txb.splitCoins(txb.object(coins[0].coinObjectId), [0]);
        txb.mergeCoins(coin, coins.map((c) => c.coinObjectId));
        const [depositCoin] = txb.splitCoins(coin, [amount]);
        txb.transferObjects([coin], address);
        if (receipt.length == 0) {
            const [receipt] = txb.moveCall({
                target: `0x1::option::none`,
                typeArguments: [(0, index_js_1.getConf)().ALPHA_POOL_RECEIPT],
                arguments: [],
            });
            txb.moveCall({
                target: `${(0, index_js_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::alphapool::user_deposit`,
                typeArguments: [(0, index_js_1.getConf)().ALPHA_COIN_TYPE],
                arguments: [
                    txb.object((0, index_js_1.getConf)().VERSION),
                    receipt,
                    txb.object((0, index_js_1.getConf)().ALPHA_POOL),
                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    depositCoin,
                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else {
            const [someReceipt] = txb.moveCall({
                target: `0x1::option::some`,
                typeArguments: [(0, index_js_1.getConf)().ALPHA_POOL_RECEIPT],
                arguments: [txb.object(receipt[0].objectId)],
            });
            txb.moveCall({
                target: `${(0, index_js_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::alphapool::user_deposit`,
                typeArguments: [(0, index_js_1.getConf)().ALPHA_COIN_TYPE],
                arguments: [
                    txb.object((0, index_js_1.getConf)().VERSION),
                    someReceipt,
                    txb.object((0, index_js_1.getConf)().ALPHA_POOL),
                    txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                    depositCoin,
                    txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        return txb;
    }
    else {
        throw new Error("No Alpha Coins");
    }
};
exports.depositAlphaTxb = depositAlphaTxb;
const withdrawAlphaTxb = async (xTokens, withdrawFromLocked, address) => {
    const txb = new transactions_1.Transaction();
    const receipt = await (0, index_js_1.getReceipts)("ALPHA", address, true);
    if (receipt.length > 0) {
        txb.moveCall({
            target: `${(0, index_js_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::alphapool::user_withdraw`,
            typeArguments: [(0, index_js_1.getConf)().ALPHA_COIN_TYPE],
            arguments: [
                txb.object((0, index_js_1.getConf)().VERSION),
                txb.object(receipt[0].objectId),
                txb.object((0, index_js_1.getConf)().ALPHA_POOL),
                txb.object((0, index_js_1.getConf)().ALPHA_DISTRIBUTOR),
                txb.pure.u64(xTokens),
                txb.object((0, index_js_1.getConf)().CLOCK_PACKAGE_ID),
                txb.pure.bool(withdrawFromLocked),
            ],
        });
        txb.setSender(address);
        // const estimatedGasBudget = await getEstimatedGasBudget(txb, address);
        // if (estimatedGasBudget) txb.setGasBudget(estimatedGasBudget);
        return txb;
    }
    else {
        throw new Error("No receipt found!");
    }
};
exports.withdrawAlphaTxb = withdrawAlphaTxb;
//# sourceMappingURL=alpha.js.map